// Copyright (c) 2016 Deere & Company

import actions from '../../../../sharedmodules/actions-list';

export const updateSearchParams = (name, value) => ({
    name,
    type: actions.UPDATE_DEALER_SEARCH_PARAMS,
    value,
});
